import styled, {css} from 'styled-components';

const Container = styled.div`
	width: 100%;
	height: 48px;
	position: absolute;
	top: 0;
	left: 0;

	display: flex;
	align-items: center;
	justify-content: flex-end;

	${({theme}) => css`
		gap: ${theme.spacing('2x')};
		justify-content: space-between;
		border-bottom: none;
	`}
`;

const ButtonActionCalendar = styled.button`
	border: 0;
	background: transparent;
	cursor: pointer;

	width: 32px;
	height: 32px;

	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		background: rgba(4, 30, 66, 0.05);
		border-radius: 8px;
	}

	&:disabled {
		opacity: 0.5;
	}

	${({theme}) => css`
		&:focus {
			border-radius: 4px;
			outline: 6px solid rgba(2, 108, 182, 0.2);
			border: 2px solid ${theme.colors.brand.primary.blue};
		}

		&:nth-child(1) {
			margin-left: ${theme.spacing('5x')};
		}

		&:nth-child(2) {
			margin-right: ${theme.spacing('4x')};
		}
	`}
`;

export {Container, ButtonActionCalendar};
